import parse from "json-templates";
import { URL } from "./constants";
const urlsTemplate = parse(URL.URL_PATTERN);

class UrlResolver {
  constructor(params) {
    params.gcpEnv = params.gcpEnv ? params.gcpEnv + "-" : ""; // `d1-...`

    params.dpdEnv = params.dpdEnv ? params.dpdEnv + "-" : ""; // qa6-...

    this.urls = urlsTemplate(params);
  }

  getUrl(attr) {
    return this.urls[attr];
  }

}

export default UrlResolver;